"use client";
import { createContext, useContext } from "react";
const StoreContext = createContext(null);
function useStore() {
  const store = useContext(StoreContext);
  if (store == null) {
    throw new Error("`useStore` must be used within a `StoreProvider`");
  }
  return store;
}
export {
  StoreContext,
  useStore
};
//# sourceMappingURL=use-store.js.map